import React, { useEffect, useState } from 'react';
import './AnimatedTrendingList.css';

const AnimatedTrendingList = ({ trending, delay = 100 }) => {
    const [visibleItems, setVisibleItems] = useState(new Set());

    useEffect(() => {
        // Animate each item one by one
        trending.forEach((item, index) => {
            setTimeout(() => {
                setVisibleItems(prev => new Set([...prev, item.id]));
            }, delay * index);
        });
    }, [trending, delay]);

    return (
        <ul className="trending-list">
            {trending.map((item) => (
                <li
                    key={item.id}
                    style={{
                        opacity: visibleItems.has(item.id) ? 1 : 0,
                        transform: `translateX(${visibleItems.has(item.id) ? 0 : '-20px'})`,
                        transition: 'opacity 0.5s ease, transform 0.5s ease',
                        marginBottom: '8px'
                    }}
                >
                    <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-blue-500 transition-colors"
                    >
                        {item.title}
                    </a>
                </li>
            ))}
        </ul>
    );
};

export default AnimatedTrendingList;